module.exports = __webpack_public_path__ + "static/media/favicon-sph706.0eb3c030.ico";